import React, { useEffect, useRef, useState } from "react";
import "./Stock.css";
import Add from "../../assets/svg/Add.svg";
import { useNavigate } from "react-router-dom";
import { Checkbox, ClickAwayListener, FormControlLabel, FormGroup, IconButton, Paper, Popper } from "@mui/material";
import { DeleteOutline,  Search, Tune } from "@mui/icons-material";
import axios from "axios";
import { useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import {  newHost } from "../Categories/CategoryProfile";
import { newImageUrl } from "../Manufacturers/ManufactureProfile";
import defaultImage from "../../assets/svg/defultImage.svg";
import { SquarePen, PencilSquare, EditIcon } from "lucide-react";
import DeleteModal from "../../components/Modals/DeleteModal";
import { toast } from "react-toastify";
import { RightOutlined } from "@ant-design/icons";

const Vendors = () => {
  const navigate = useNavigate();
const [searchText, setSearchText] = useState("");

 const { user } = useSelector((state) => state.auth);
          
        const token = user?.token;
    
      const newHeaders = {
        Authorization: "Bearer " + token,
      };

  //Model
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null); 

  
  const Close = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShow(false);
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);


  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  useEffect(() => {
    if (show) {
      document.addEventListener("click", Close);
    } else {
      document.removeEventListener("click", Close);
    }
    return () => document.removeEventListener("click", Close);
  }, [show]);

  //header updates

  const paginationModel = { page: 0, pageSize: 10 };

  const columns = [   
    {
      field: "name",
      headerName: "Company Name",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return(
          <div  className="d-flex align-items-center justify-content-center gap-1">
                      <img className="service-icon" src={`${params.row?.logo_url? newImageUrl+params.row?.logo_url :defaultImage}`} alt="" />
                 <p className="m-0">{params.row?.name}</p>
          </div>
        )
      }
    },
    {
      field: "username",
      headerName: "Vendor Name",
      flex: 0.8,
      minWidth: 110,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 0.6,
      minWidth: 90,
    },
    {
      field: "services",
      headerName: "Services Category",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <div  style={{
                maxHeight: "70px",
                overflowX: "scroll",
                overflowY: "hidden",
                lineHeight: "3.5",
                width: "100%",
              }} className="d-flex gap-2 overflow-x-auto ">
            {params?.row?.services?.map((service)=>
              <>
            <div className="d-flex align-items-center gap-1 ">
            <img className="service-icon " src={`${service?.image? newImageUrl+service?.image.image_url :defaultImage} `} alt="" />
            <p className="m-0">{service?.name}</p>
            </div>
              </>

            )}
          </div>
        )
      }
    },
    {
      field: "contacts",
      headerName: "Contact Info",
      flex: 0.9,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <div className="">
            {params?.row?.branches?.map((branch)=> branch.contacts?.map((contact)=>
               <p className="m-0 text-truncate">{contact?.info}</p>

            ).slice(0,1))}
          </div>
        )
      }
    },
    {
      field: "branches",
      headerName: "Main Branch",
      flex: 0.8,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <div className="">
            {params?.row?.branches?.map((branch)=>
               <p className="m-0">{branch?.name}</p>

            ).slice(0,1)}
          </div>
        )
      }
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const handleEdit = (event, provider) => {
          event.stopPropagation();
          navigate(`/stock/vendors/supplier/${provider.id}`)
        
        };

        return (
          <div>
            <IconButton
              onClick={(e) => handleEdit(e, params.row)}
              color="default"
              aria-label="edit"
              size="small"
              style={{width:"30%"}}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={(e) => handleDeleteVendorShow(params.row?.id, e)}
              color="error"
              aria-label="delete"
              size="small"
              style={{width:"30%"}}
            >
              <DeleteOutline />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation()
              navigate(`/stock/vendors/${params.row.id}`)
            }}
              color="default"
              aria-label="navigate"
              size="small"
              style={{width:"30%"}}
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const [filterItems, setFilterItems] = useState([]);

  const [vendors, setVendors] = useState([])
  const [showDeleteVendor , setShowDeleteVendor] = useState(false)
   const [providerId , setProviderId] = useState(false)

  const handleDeleteVendorShow = (id,e)=>{
    e.stopPropagation()
    setShowDeleteVendor(true)
    setProviderId(id)
  }
  const handleDeleteVendorClose = ()=>{
    setShowDeleteVendor(false)
  }

  const getVendorsData = async () => {
    try {
      const response = await axios.get(`${newHost}portal/providers-with-branches`, {
        headers:
          newHeaders,
        
      })
      console.log(response);
      const fetchedVendors = response.data.data.providers;
      
    setVendors(fetchedVendors);
      const allServices = fetchedVendors.flatMap(v => v.services || []);
      
      const uniqueServices = Array.from(
        new Map(allServices.map(service => [service.id, service])).values()
      );
      console.log("services",uniqueServices);

      setFilterItems(uniqueServices);
      
    } catch (error) {
      console.log(error);

    }
  }
  const handleDeleteVendor = async ()=>{
    try {
      const response = await axios.delete(`${newHost}portal/providers/${providerId}`,{
        headers :newHeaders
      })
      toast.success(response.data.data?.message)
      getVendorsData()
      setShowDeleteVendor(false)
    } catch (error) {
      toast.error(error.response.data?.message)
    }
  }
  useEffect(() => {
    getVendorsData()
  }, [])
  const [checkedItems, setCheckedItems] = useState([]); 
const [filteredVendors, setFilteredVendors] = useState([]);

const handleToggle = (serviceId) => {
  setCheckedItems(prev =>
    prev.includes(serviceId)
      ? prev.filter(id => id !== serviceId)
      : [...prev, serviceId]
  );
};



useEffect(() => {
  let filtered = vendors;

  if (checkedItems.length > 0) {
    filtered = filtered.filter(vendor =>
      vendor.services?.some(service => checkedItems.includes(service.id))
    );
  }

  if (searchText.trim() !== "") {
    const lowerSearch = searchText.toLowerCase();
    filtered = filtered.filter(vendor =>
      vendor.name?.toLowerCase().includes(lowerSearch) ||
      vendor.description?.toLowerCase().includes(lowerSearch) 
    );
  }

  setFilteredVendors(filtered);
}, [checkedItems, vendors, searchText]);




  return (
    <>
            <DeleteModal showDelete={showDeleteVendor}
            handleDeleteClose={handleDeleteVendorClose}
            textMessage={" Are you sure you want to delete this Vendor?"}
            deleteFunction={handleDeleteVendor} />
      <div className="StockPage m-4">
        <div className="d-flex justify-content-between align-items-center input-group-responsive ">
          <h6 className="stockPage_title m-0">
            Vendors
            <span>{vendors.length}</span>
          </h6>
          <div className="stockPage_add my-1" onClick={() => navigate(`/stock/vendors/supplier`)}>
            <img className="stockPage_add_img" src={Add} alt="" />
            <div className="stockPage_add_text">Add New Vendor </div>
          </div>
          {/* {show && (
            <div className="stockPage_add-dropdown_content">
              <div onClick={() => navigate(`/stock/vendors/supplier`)}>
                Supplier
              </div>
              <div onClick={() => navigate(`/stock/vendors/supplier`)}>
                Provider
              </div>
              <div onClick={() => navigate(`/stock/vendors/supplier`)}>
                Supplier & Provider
              </div>
            </div>
          )} */}
        </div>
        {/* <div className="StockPage_SacondRow">
          <div className="StockPage-serchBar">
            <input
              type="text"
              placeholder="Search by item code, name, category... "
              value={searchTerm}
              className="serchAndFilter-input_Stock"
              onChange={handleSearchChange}
            />
            <img src={SearchIcon} className="serchAndFilter-icon_Stock" />
          </div>
          <select
            value={selectedCategory}
            onChange={handleCategoryChange}
            className="serchAndFilter-select_stock"
          >
            <option value={"All"}>Choose Category for Filtration</option>
            {categories.map((category) => (
              <option key={category} value={category}>
                {category} '{categoryCounts[category]}'
              </option>
            ))}
          </select>
        </div> */}
        <div className='row  align-items-center '>
          <div className='col-md-6 col-sm-12 d-flex align-items-center  gap-3 py-2'> 
            </div>

          <div className='col-md-6 col-sm-12 justify-content-end d-flex gap-2 my-3 input-group-responsive'>
               <div className="w-100 d-flex align-items-center justify-content-end position-relative ">
                                            <input className='w-100 py-2 ps-3 pe-5  rounded-2 search-point' type="text" placeholder="Search targeting rules" 
                                             value={searchText}
                                             onChange={(e) => setSearchText(e.target.value)}
                                            />
                                            <Search sx={{ color: " #535353", position: "absolute" }} />
                              
                                          </div>
            <button onClick={handleClick} className='btn btn-light'>        <Tune /></button>


            <Popper open={open} anchorEl={anchorEl} placement="bottom-end">
              <ClickAwayListener onClickAway={handleClose}>
                <Paper sx={{ mt: 1, p: 2, boxShadow: 3, borderRadius: 2, minWidth: 200 }}>
                 
                  <FormGroup>
  {filterItems.map((item) => (
    <FormControlLabel
      key={item.id}
      control={
        <Checkbox
          checked={checkedItems.includes(item.id)}
          onChange={() => handleToggle(item.id)}
        />
      }
      label={item.name}
    />
  ))}
</FormGroup>

                </Paper>
              </ClickAwayListener>
            </Popper>
          </div>

        </div>
       
             <div className="data-grid-small">
              <Paper sx={{ height: "auto", width: "100%" }}>
                      <DataGrid
                        autoHeight
                        rows={filteredVendors}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[5, 10]}
                        checkboxSelection
                        sx={{ border: 0 }}
                      />
                    </Paper>
             </div>
      </div>
    </>
  );
};

export default Vendors;
